__turbopack_context__.v({
  "productListItem": "C2pURa_productListItem",
  "seeMoreText": "C2pURa_seeMoreText",
});
